(function () {
    fabric.util.saveObjectTransform = function saveObjectTransform(target) {
        // Snapshot per child, not a deep clone: a clone reaches the whole scene through
        //  object.canvas and stayed in _currentTransform for the whole gesture, so transforming a
        //  multiple selection stuttered on heavy content (a text shape's paragraph, for one).
        //  Safe because every consumer only reads these numbers back, never the objects themselves
        const objects =
            target.type == 'activeSelection' ? target.getObjects().map((object) => saveObjectTransform(object)) : null;
        return {
            objects,
            width: target.width,
            height: target.height,
            verticalDiameter: target.verticalDiameter,
            horizontalDiameter: target.horizontalDiameter,
            scaleX: target.scaleX,
            scaleY: target.scaleY,
            skewX: target.skewX,
            skewY: target.skewY,
            angle: target.angle,
            left: target.left,
            flipX: target.flipX,
            flipY: target.flipY,
            top: target.top
        };
    };

    fabric.util.createColorType = function (options) {
        if (!options || typeof options !== 'object') return null;
        if (typeof options.colorStops !== 'undefined' && Array.isArray(options.colorStops)) {
            if (options instanceof fabric.Gradient) return options;
            return fabric.util.createGradient(options);
        }
        if (typeof options.colors !== 'undefined' && Array.isArray(options.colors)) {
            return fabric.util.createPalette(options);
        }
        return null;
    };

    fabric.util.createGradient = function (options) {
        const colorStops = (options.colorStops || []).map((colorStop) => ({
            offset: colorStop.offset !== undefined ? colorStop.offset / 100 : 0,
            color: colorStop.hex || '#000000',
            opacity: colorStop.alpha !== undefined ? colorStop.alpha : 1
        }));
        const transform = {
            scaleX: 1,
            scaleY: 1,
            skewX: 0,
            skewY: 0,
            angle: options.angle || 0,
            translateX: 0,
            translateY: 0
        };
        const matrix = fabric.util.composeMatrix(transform);
        return new fabric.Gradient({
            type: options.type || 'linear',
            gradientUnits: options.gradientUnits || 'percentage',
            coords: {
                x1: options.x1 || 0,
                y1: options.y1 || 0.5,
                x2: options.x2 || 1,
                y2: options.y2 || 0.5
            },
            colorStops: colorStops,
            angle: options.angle || 0,
            gradientTransform: matrix || fabric.iMatrix
        });
    };

    fabric.util.createPalette = function (options) {
        return new fabric.Palette({
            type: options.type || 'letter',
            colors: options.colors || [],
            id: options.id || null
        });
    };
})();
